'use strict';

import AxiosService from '../AxiosService';
import SharedStatusService from '../shared/SharedStatusService';

const ADDRESS_ENDPOINT = "/api/v1/addresses";
const MECHANIC_READY = "/api/v1/addresses/mechanic/ready";


export default class VisitService {
    constructor() {
        this.service = new AxiosService();
        this.sharedStatusService = new SharedStatusService();
    }

    schedule(id, visit) {
        return this.service.put(ADDRESS_ENDPOINT + "/" + id + "/appointment", visit);
    }

    setMechanicReady(addressId) {
        return this.service.post(MECHANIC_READY, { addressId: addressId });
    }

    resolveStatuses() {
        return this.sharedStatusService.resolveCancelStatuses();
    }

    isOtherState(value) {
        return this.sharedStatusService.resolveOtherStatuses()
                .filter(e => e.key === value)
                .length === 1;
    }

    saveLog(id, remarStatusRequest) {
        return this.service.post(ADDRESS_ENDPOINT + "/" + id + "/status", remarStatusRequest);
    }

}